export default {
  methods: {
    handleGetStarted: function () {
      let self = this;
      // Only update if this is first time (hasSeenWelcome is false or undefined)
      if (self.$app.data.settings && !self.$app.data.settings.hasSeenWelcome) {
        let settings = self.$app.data.settings;
        settings.hasSeenWelcome = true;

        // Update in Firestore
        db.collection('settings').doc(self.$app.data.user.uid).update({
          hasSeenWelcome: true
        }).then(() => {
          console.log('Welcome marked as seen');
        }).catch(err => {
          console.error('Error updating hasSeenWelcome', err);
        });

        // Update in app data
        self.$app.data.settings = settings;
      }
      // Popup will close automatically due to popup-close class
    }
  },
  on: {
    popupOpen: function () {
      console.log('Welcome popup opened');
    }
  },
  id: '3a5a200d11',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=popup id=welcome-popup><div class=view><div class=page><div class=navbar><div class=navbar-bg></div><div class=navbar-inner><div class=title>Welcome</div><div class=right><a class="link popup-close">Close</a></div></div></div><div class=page-content><!-- Hero Section --><div class=welcome-hero><h1 class=welcome-title>Track Your Healing Journey</h1><p class=welcome-subtitle>Build mindfulness through daily reflection and healthy habits</p></div><!-- How It Works Section --><div class=welcome-section><h2 class=section-heading>How It Works</h2><div class=feature-card><div class=feature-icon>📝</div><div class=feature-content><h3 class=feature-title>Daily Entries</h3><p class=feature-description>Log your sobriety level, soothing activities, and progress each day</p></div></div><div class=feature-card><div class=feature-icon>🏛️</div><div class=feature-content><h3 class=feature-title>12 Pillars of Healing</h3><p class=feature-description>Read and reflect on powerful principles (3 per day based on your program progress)</p></div></div><div class=feature-card><div class=feature-icon>🧘</div><div class=feature-content><h3 class=feature-title>Soothing Activities</h3><p class=feature-description>Track spiritual, physical, emotional, and social wellness practices</p></div></div><div class=feature-card><div class=feature-icon>⭐</div><div class=feature-content><h3 class=feature-title>Points System</h3><p class=feature-description>Earn points for healthy choices (Goal: 18+ points daily for optimal results)</p></div></div></div><!-- Best Results Section --><div class=welcome-section><h2 class=section-heading>For Best Results</h2><div class=callout-box><p><strong>Make a commitment to log an entry every day.</strong> Consistency is key to developing new neural pathways and maintaining your healing journey.</p><p class=privacy-note>Your progress is private and secure.</p></div></div><!-- CTA Button --><div class=welcome-cta><button class="button button-large button-fill popup-close" @click=handleGetStarted()>Get Started</button></div></div></div></div></div>';
      return r;
    }(this);
  },
  style: `
  /* Welcome Popup Container */
  #welcome-popup .page-content {
    padding-bottom: 32px;
  }

  /* Hero Section */
  .welcome-hero {
    text-align: center;
    padding: 32px 24px 24px;
    background: linear-gradient(135deg, #f8fafb 0%, #ffffff 100%);
    border-bottom: 1px solid #e8eef2;
  }

  .welcome-title {
    font-size: 26px;
    font-weight: 700;
    line-height: 1.3;
    color: #1a1a1a;
    margin: 0 0 12px;
    letter-spacing: -0.02em;
  }

  .welcome-subtitle {
    font-size: 16px;
    line-height: 1.5;
    color: #5a6c7a;
    margin: 0;
    font-weight: 400;
  }

  /* Sections */
  .welcome-section {
    padding: 28px 16px 12px;
  }

  .section-heading {
    font-size: 18px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 20px 0;
    letter-spacing: -0.01em;
  }

  /* Feature Cards */
  .feature-card {
    display: flex;
    gap: 16px;
    padding: 16px;
    margin-bottom: 12px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e8eef2;
    transition: all 0.2s ease;
  }

  .feature-card:last-child {
    margin-bottom: 0;
  }

  .feature-card:active {
    background: #f8fafb;
    transform: scale(0.99);
  }

  .feature-icon {
    font-size: 32px;
    line-height: 1;
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
    border-radius: 10px;
  }

  .feature-content {
    flex: 1;
    min-width: 0;
  }

  .feature-title {
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 4px;
    line-height: 1.4;
  }

  .feature-description {
    font-size: 14px;
    line-height: 1.5;
    color: #5a6c7a;
    margin: 0;
    font-weight: 400;
  }

  /* Callout Box */
  .callout-box {
    background: linear-gradient(135deg, #f0f9ff 0%, #e6f3ff 100%);
    border: 1px solid #b8deff;
    border-radius: 12px;
    padding: 20px;
  }

  .callout-box p {
    font-size: 15px;
    line-height: 1.6;
    color: #1a4d6e;
    margin: 0 0 12px;
  }

  .callout-box p:last-child {
    margin-bottom: 0;
  }

  .privacy-note {
    font-size: 13px;
    color: #4a7a99;
    font-style: italic;
  }

  /* CTA Section */
  .welcome-cta {
    padding: 24px 16px 8px;
  }

  .welcome-cta .button {
    border-radius: 12px;
    font-size: 17px;
    font-weight: 600;
    letter-spacing: 0.01em;
    text-transform: none;
    height: 52px;
    box-shadow: 0 4px 12px rgba(0, 122, 255, 0.25);
  }

  .welcome-cta .button:active {
    box-shadow: 0 2px 6px rgba(0, 122, 255, 0.2);
  }

  /* Responsive adjustments */
  @media (max-width: 360px) {
    .welcome-title {
      font-size: 24px;
    }

    .feature-card {
      gap: 12px;
      padding: 14px;
    }

    .feature-icon {
      font-size: 28px;
      width: 40px;
      height: 40px;
    }
  }
`,
  styleScoped: false
};